<template>
  <td :class="color">{{ formattedBalance }}</td>
</template>

<script>
  import utils from '../../../../utils';
  import { mapGetters } from 'vuex';

  export default {
    name: "TableBalanceLabel",
    props: ['balance'],
    computed: {
      ...mapGetters(['currency']),
      formattedBalance() {
        return utils.convertSystemToCurrency(this.balance, this.currency);
      },
      color() {
        return this.balance <= 0 ? 'red' : 'green';
      },
    }
  }
</script>

<style scoped>
  .green {
    text-align: right;
    color: #093;
  }
  .red {
    text-align: right;
    color: #f08080;
  }
</style>

